import React, { useEffect, useState } from 'react'
import {
    format,
    addDays,
    subDays,
    getWeek,
    addWeeks,
    subWeeks,
    parseISO,
    lastDayOfWeek,
    parse,
} from 'date-fns'
import { Button, Radio, RadioGroup, FormControlLabel, FormControl } from '@material-ui/core'
import SchedulePickupContext from '@/product/context/schedulePickup/schedulePickupContext'
import '@/product/components/species/components/pickup/schedule.css'
import moment from 'moment'
import CustomCommonContext from '@/custom/context/common/commonContext'
import { useContext } from 'react'
export default function Scheduler(props) {
    // Create a mapping of abbreviated day names to their full names
    const dayMap = {
        Mon: 'monday',
        Tue: 'tuesday',
        Wed: 'wednesday',
        Thu: 'thursday',
        Fri: 'friday',
        Sat: 'saturday',
        Sun: 'sunday',
    }
    const [currentMonth, setCurrentMonth] = useState(new Date())
    const [selectedDate, setSelectedDate] = useState('')
    const [startDate, setStartDate] = useState(new Date())
    const [bookedSlots, setBookedSlots] = useState([])
    const [maxOrders, setMaxOrders] = useState('')
    const [disabledBack, setDisabledBack] = useState(true)
    const [disabledNext, setDisableNext] = useState(false)
    const [selectedTime, setSelectedTime] = useState('')
    const [singleDate, setSingleDate] = useState('')
    const scheduleContext = useContext(SchedulePickupContext)
    const { getSchedulePickupTiming, schedule_data, responseStatus, clearResponse } =
        scheduleContext

    const [availableSlots, setAvailableSlots] = useState([])
    const [currentBreakSt, setCurrentBreakSt] = useState('')
    const [currentBreakEn, setCurrentBreakEn] = useState('')

    const [dayOfWeek, setDayOfWeek] = useState('')
    const [timings, setTimings] = useState({
        default: [],
        scheduled: [],
    })

    const customCommonContext = useContext(CustomCommonContext)
    const { setCurrentMembership, allBiddingPlan, membership, alldata_all_dropdown, allLocations } =
        customCommonContext

    const pickupEndDaysLimit = props?.pickupDaysLimit ? props?.pickupDaysLimit : 0
    const paidDate = props.paidDate ? props.paidDate : undefined

    const handleDateChange = (event) => {
        let formattedDate = moment(event.target.value, 'ddd DD MMM')
        let getDateSlots = moment(event.target.value, 'YYYY-MM-DD')
        setDayOfWeek(formattedDate.format('dddd'))
        setSingleDate(event.target.value)
        getSchedulePickupTiming(
            {
                limit: 12,
                page: 1,
                orderby: 'b.common_invoice,desc',
                order: '',
                scheduled: 1,
                filters: {
                    schedule_date: {
                        value: getDateSlots,
                        type: 'dateequal',
                        field: 'spu.booking_start_date',
                    },
                },
                action: 'won',
            },
            'singleSlot',
        )
    }

    const handleTimeChange = (event) => {
        setSelectedTime(event.target.value)
    }

    const changeWeekHandle = (btnType) => {
        const today = moment()
        const offset = btnType === 'prev' ? -7 : 7
        const newStartDate = addDays(startDate, offset)
        setStartDate(newStartDate)

        if (moment(newStartDate).isSame(today, 'day')) {
            setDisabledBack(true)
            setDisableNext(false)
        } else {
            setCurrentMonth(
                btnType === 'prev' ? subWeeks(currentMonth, 1) : addWeeks(currentMonth, 1),
            )
            setDisabledBack(false)
            setDisableNext(false)
        }
    }

    const schedulePickUpDate = (pickup, data) => {
        if (pickup && pickupEndDaysLimit) {
            let pickupDate = new Date(pickup)
            let workingDaysCount = 0

            // Start counting from the next day after pickup
            pickupDate.setDate(pickupDate.getDate() + 1)

            while (workingDaysCount < pickupEndDaysLimit) {
                let dayKey = getDayKey(pickupDate.getDay())

                if (data[dayKey] === 'open' || data[dayKey] === 'all_day') {
                    workingDaysCount++
                }

                pickupDate.setDate(pickupDate.getDate() + 1)
            }

            // After reaching the required number of working days, set the final pickup date
            pickupDate.setDate(pickupDate.getDate() - 1)

            let formateDateTime = pickupDate.toISOString()

            return formateDateTime
        } else {
            return '-'
        }
    }

    // Helper function to get day key based on day index
    const getDayKey = (index) => {
        const days = [
            'sunday_available',
            'monday_available',
            'tuesday_available',
            'wednesday_available',
            'thursday_available',
            'friday_available',
            'saturday_available',
        ]
        return days[index]
    }

    const renderWeekDays = () => {
        const dateFormat = 'EEE d MMM yyyy'
        const weekDays = []
        const today = moment()
        const dayFormat = 'EEEE'
        let orderData = allLocations.filter(
            (item) => item.active == 1 && item.id == props.locationId,
        )[0]?.max_days_limit

        let slotLimit = orderData ? orderData : 7

        for (let i = 0; i < slotLimit; i++) {
            const selDay = addDays(startDate, i)
            const formattedDate = format(selDay, dateFormat)
            const formattedDay = format(selDay, dayFormat).toLowerCase()
            let day = formattedDate?.split(' ')[0]
            let date = formattedDate?.split(' ')[1]
            let month = formattedDate?.split(' ')[2]

            let locationsData = allLocations.filter(
                (item) => item.active == 1 && item.id == props.locationId,
            )[0]

            if (moment(selDay).isBefore(today, 'day')) {
            } else if (
                paidDate &&
                moment(selDay).isAfter(schedulePickUpDate(paidDate, locationsData), 'day') &&
                pickupEndDaysLimit
            ) {
                if (!disabledNext) {
                    setDisableNext(true)
                }
            } else if (
                slotLimit &&
                locationsData[`${formattedDay}_available`] &&
                locationsData[`${formattedDay}_available`] == 'closed'
            ) {
                slotLimit = slotLimit + 1
            } else {
                weekDays.push(
                    <FormControlLabel
                        className={`${formattedDate == selectedDate ? 'selected' : ''}`}
                        key={i}
                        value={formattedDate}
                        control={<Radio />}
                        label={
                            <div className="dayPreview">
                                <span>{day}</span>
                                <span>{date}</span>
                                <span>{month}</span>
                            </div>
                        }
                        disabled={
                            locationsData[`${formattedDay}_available`] == 'closed' ? true : false
                        }
                    />,
                )
            }
        }

        return (
            <FormControl className="schedulerDate">
                <RadioGroup
                    aria-label="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={selectedDate}
                    onChange={handleDateChange}
                >
                    {weekDays}
                </RadioGroup>
            </FormControl>
        )
    }

    const convertTime = (data) => {
        const [hours, minutes] = data.split(':')
        const hours12 = hours % 12 || 12
        const meridian = hours >= 12 ? 'PM' : 'AM'

        return `${hours12}:${minutes} ${meridian}`
    }

    // const generateTimeSlots = () => {
    //     let day = selectedDate?.split(' ')[0]
    //     let sTime =
    //         timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Day_Times[0]
    //             ?.start_time || '12:00 AM'
    //     let eTime =
    //         timings?.default[0]?.general?.find((ele) => ele.Day.includes(day))?.Day_Times[0]
    //             ?.end_time || '11:59 PM'
    //     if (
    //         localStorage.getItem('Browsertype') == 'Safari' ||
    //         localStorage.getItem('Browsertype') == 'Mobile Safari'
    //     ) {
    //         sTime = convertTime12to24(sTime)
    //         eTime = convertTime12to24(eTime)
    //     }
    //     console.log(sTime, eTime, timings, 'timings')
    //     const sDate = new Date(`2000-01-01 ${sTime}`)
    //     const eDate = new Date(`2000-01-01 ${eTime}`)

    //     const timeSlots = []

    //     const interval = 60 * 5 * 1000
    //     let currentSlot = sDate

    //     while (currentSlot <= eDate) {
    //         const slotStart = currentSlot.toLocaleTimeString([], {
    //             hour: '2-digit',
    //             minute: '2-digit',
    //         })
    //         timeSlots.push(slotStart)
    //         currentSlot = new Date(currentSlot.getTime() + interval)
    //     }
    //     return timeSlots
    // }

    const convertTime12to24 = (time12h) => {
        const [time, modifier] = time12h.split(' ')

        let [hours, minutes] = time.split(':')

        if (hours === '12') {
            hours = '00'
        }

        if (modifier === 'PM') {
            hours = parseInt(hours, 10) + 12
        }

        return `${hours}:${minutes}`
    }

    const generateTimeSlots = () => {
        let day = selectedDate?.split(' ')[0]
        let locationsData = allLocations.filter(
            (item) => item.active == 1 && item.id == props.locationId,
        )[0]

        const formattedDay = dayMap[day]
        let sTime =
            locationsData[`${formattedDay}_available`] == 'all_day'
                ? '12:00 AM'
                : locationsData[`${formattedDay}_starting`]
                ? locationsData[`${formattedDay}_starting`]
                : '12:00 AM'
        let eTime =
            locationsData[`${formattedDay}_available`] == 'all_day'
                ? '11:59 PM'
                : locationsData[`${formattedDay}_ending`]
                ? locationsData[`${formattedDay}_ending`]
                : '11:59 PM'
        const userAgent = window.navigator.userAgent
        if (userAgent.indexOf('Safari') > -1) {
            sTime = convertTime12to24(sTime)
            eTime = convertTime12to24(eTime)
        }
        const sDate = new Date(`2000-01-01 ${sTime}`)
        const eDate = new Date(`2000-01-01 ${eTime}`)

        if (
            locationsData[`${formattedDay}_available`] &&
            locationsData[`${formattedDay}_available`] !== 'closed' &&
            locationsData[`${formattedDay}_break_start`] &&
            locationsData[`${formattedDay}_break_end`]
        ) {
            const breakstart = convertTime(locationsData[`${formattedDay}_break_start`])
            const breakend = convertTime(locationsData[`${formattedDay}_break_end`])
            setCurrentBreakSt(breakstart)
            setCurrentBreakEn(breakend)
        }

        const timeSlots = []
        const slotminute = locationsData.slot_minutes ? locationsData.slot_minutes : 5
        const interval = 60 * slotminute * 1000
        let currentSlot = sDate

        while (currentSlot <= eDate) {
            const slotStart = currentSlot.toLocaleTimeString([], {
                hour: '2-digit',
                minute: '2-digit',
            })
            timeSlots.push(slotStart)

            currentSlot = new Date(currentSlot.getTime() + interval)
        }
        return timeSlots
    }

    useEffect(() => {
        if (selectedDate && selectedDate !== '') {
            setAvailableSlots(generateTimeSlots())
        }
    }, [selectedDate])

    useEffect(() => {
        if (props.pickupData && props.pickupData.length) {
            const parsedData = parseISO(props.pickupData[0].schedulepickup_booking_start_date)
            const formattedDate = format(parsedData, 'EEE d MMM yyyy')
            const formattedTime = format(parsedData, 'hh:mm a')
            setSelectedDate(formattedDate)
            setSelectedTime(formattedTime)
        }
    }, [props.pickupData])

    function addDays(date, day) {
        let new_date = new Date(date.getTime())
        new_date.setDate(new_date.getDate() + day)
        return new_date
    }

    const parseTimeString = (startTime, endTime, currentTime) => {
        const startTimeHours = parseInt(startTime.split(':')[0], 10)
        const startTimeMinutes = parseInt(startTime.split(':')[1].split(' ')[0], 10)
        const startTimePeriod = startTime.split(' ')[1]
        const endTimeHours = parseInt(endTime.split(':')[0], 10)
        const endTimeMinutes = parseInt(endTime.split(':')[1].split(' ')[0], 10)
        const endTimePeriod = endTime.split(' ')[1]
        const currentTimeHours = parseInt(currentTime.split(':')[0], 10)
        const currentTimeMinutes = parseInt(currentTime.split(':')[1].split(' ')[0], 10)
        const currentTimePeriod = currentTime.split(' ')[1]

        const convertTo24HourFormat = (hours, period) => {
            if (period === 'PM' && hours !== 12) {
                return hours + 12
            } else if (period === 'AM' && hours === 12) {
                return 0
            } else {
                return hours
            }
        }

        const convertedStartTime = convertTo24HourFormat(startTimeHours, startTimePeriod)
        const convertedEndTime = convertTo24HourFormat(endTimeHours, endTimePeriod)
        const convertedCurrentTime = convertTo24HourFormat(currentTimeHours, currentTimePeriod)

        if (
            (convertedCurrentTime > convertedStartTime &&
                convertedCurrentTime < convertedEndTime) ||
            (convertedCurrentTime === convertedStartTime &&
                currentTimeMinutes >= startTimeMinutes) ||
            (convertedCurrentTime === convertedEndTime && currentTimeMinutes <= endTimeMinutes)
        ) {
            return true
        } else {
            return false
        }
    }

    // const parseTimeString = (timeString) => {
    //     const [hourMinute, meridian] = timeString.split(' ')
    //     const [hour, minute] = hourMinute.split(':')
    //     console.log(hour, minute, hourMinute, meridian, timeString, 'timeString')
    //     let totalMinutes = parseInt(hour, 10) * 60 + parseInt(minute, 10)

    //     // Adjust for PM
    //     if (meridian && meridian.toLowerCase() === 'pm' && hour !== 12) {
    //         totalMinutes += 12 * 60
    //     }

    //     return totalMinutes
    // }

    const checkTimeValidity = (checkTime) => {
        if (currentBreakSt !== '' && currentBreakEn !== '') {
            if (bookedSlots && bookedSlots.length && bookedSlots.includes(checkTime)) {
                let count = 0
                bookedSlots.map((data) => {
                    if (data == checkTime) {
                        count = count + 1
                    }
                })
                if (maxOrders && count > maxOrders) {
                    return true
                } else {
                    return false
                }
            } else {
                const result = parseTimeString(currentBreakSt, currentBreakEn, checkTime)
                return result
            }
            // const startTotalMinutes = parseTimeString(currentBreakSt)
            // const endTotalMinutes = parseTimeString(currentBreakEn)
            // const checkTotalMinutes = parseTimeString(checkTime)
            // console.log(startTotalMinutes, endTotalMinutes, checkTotalMinutes, 'checkTotalMinutes')
            // if (checkTotalMinutes >= startTotalMinutes && checkTotalMinutes <= endTotalMinutes) {
            //     console.log(currentBreakSt, currentBreakEn, checkTime, 'checkTimebn123')
            //     console.log(
            //         startTotalMinutes,
            //         endTotalMinutes,
            //         checkTotalMinutes,
            //         checkTime,
            //         '123456',
            //     )
            //     return true
            // } else {
            //     return false
            // }
        } else {
            return false
        }
    }

    function getDates(k, day) {
        const day_num = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
        ].indexOf(day.toLowerCase()) // converting day name to number

        let new_day = new Date()
        while (new_day.getDay() !== day_num) {
            new_day = addDays(new_day, 1)
        }

        return addDays(new_day, 0)
    }

    useEffect(() => {
        if (selectedDate !== '' && selectedTime !== '') {
            let locationsData = allLocations.filter(
                (item) => item.active == 1 && item.id == props.locationId,
            )[0]
            // const formattedDate = moment(selectedDate, 'ddd D MMM YYYY').format('MM-DD-YYYY')
            // console.log(formattedDate, 'formattedDate')
            const timeMoment = moment(selectedTime, 'hh:mm A')
            const newTimeFormat = timeMoment.add(
                locationsData.slot_minutes ? locationsData.slot_minutes : 5,
                'minutes',
            )
            const formattedTime = newTimeFormat.format('hh:mm A')
            const finalEndDate = `${selectedDate} ${formattedTime}`
            const finalDate = `${selectedDate} ${selectedTime}`
            const lastformat = moment(finalDate, 'ddd D MMM YYYY hh:mm A').format(
                'MM-DD-YYYY hh:mm a',
            )
            const lastEndFormat = moment(finalEndDate, 'ddd D MMM YYYY hh:mm A').format(
                'MM-DD-YYYY hh:mm a',
            )
            const finalValue = moment(lastformat, 'MM-DD-YYYY h:mm a').format()
            const finalEndValue = moment(lastEndFormat, 'MM-DD-YYYY h:mm a').format()
            props.updateFunc(finalValue, finalEndValue)
        }
    }, [selectedDate, selectedTime])

    useEffect(() => {
        if (schedule_data && schedule_data.from == 'singleSlot') {
            let allData = schedule_data.records.length ? schedule_data.records : []
            let orderData = ''
            if (allData.length) {
                let allSlots = []
                orderData = allLocations.filter(
                    (item) => item.active == 1 && item.id == props.locationId,
                )[0]?.slot_per_limit
                allData
                    .filter((item) => item.schedulepickup_location_id == props.locationId)
                    .map((data) => {
                        if (
                            data.schedulepickup_booking_start_date &&
                            data.schedulepickup_booking_start_date !== ''
                        ) {
                            const parsedData = parseISO(data.schedulepickup_booking_start_date)
                            const formattedTime = format(parsedData, 'hh:mm a')
                            allSlots.push(formattedTime)
                        }
                    })
                setBookedSlots(allSlots)
                if (orderData && orderData !== '') {
                    setMaxOrders(orderData)
                }
                setSelectedDate(singleDate)
            } else {
                setBookedSlots([])
                orderData = allLocations.filter(
                    (item) => item.active == 1 && item.id == props.locationId,
                )[0]?.slot_per_limit
                if (orderData && orderData !== '') {
                    setMaxOrders(orderData)
                }
                setSelectedDate(singleDate)
            }
        }
    }, [schedule_data])

    // useEffect(() => {
    //     setTimings({
    //         ...timings,
    //         default: all_timings?.default_timings,
    //         scheduled: all_timings?.scheduled_timings,
    //     })
    //     console.log(
    //         all_timings?.default_timings,
    //         getDates(
    //             1,
    //             all_timings?.default_timings[0]?.general?.find((ele) => ele.Status === 'Open')?.Day,
    //         ),
    //         'all_timings?.scheduled_timings',
    //     )
    //     setSelectedDate(
    //         format(
    //             pickupData?.booking_date
    //                 ? new Date(pickupData?.booking_date)
    //                 : getDates(
    //                       1,
    //                       all_timings?.default_timings[0]?.general?.find(
    //                           (ele) => ele.Status === 'Open',
    //                       )?.Day,
    //                   ),
    //             'EEE d MMM yyyy',
    //         ),
    //     )
    //     setSelectedTime(
    //         pickupData?.booking_date
    //             ? format(
    //                   pickupData?.booking_date
    //                       ? new Date(pickupData?.booking_date)
    //                       : getDates(
    //                             1,
    //                             all_timings?.default_timings[0]?.general?.find(
    //                                 (ele) => ele.Status === 'Open',
    //                             )?.Day,
    //                         ),
    //                   'hh:mm a',
    //               )
    //             : null,
    //     )
    // }, [allLocations])
    return (
        <div className="scheduler">
            <div className="schedulerTop">
                Calendar
                <div className="schedulerActions">
                    <Button
                        className="schedulerMove"
                        onClick={() => changeWeekHandle('prev')}
                        disabled={disabledBack}
                    >
                        <span className="material-icons">navigate_before</span>
                    </Button>

                    <Button
                        className="schedulerMove"
                        onClick={() => changeWeekHandle('next')}
                        disabled={disabledNext}
                    >
                        <span className="material-icons">navigate_next</span>
                    </Button>
                </div>
            </div>

            <div className="schedulerMain">
                {renderWeekDays()}
                <div className="schedulerTime">
                    <h4 className="stTitle">{selectedDate}</h4>
                    {selectedDate ? (
                        <div className="timeUnits">
                            <FormControl>
                                <RadioGroup
                                    aria-label="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={selectedTime}
                                    onChange={handleTimeChange}
                                >
                                    {availableSlots?.map((d, i) => (
                                        <FormControlLabel
                                            key={i}
                                            value={d}
                                            control={
                                                <Radio
                                                    disabled={
                                                        (new Date(
                                                            `${moment().format('YYYY-MM-DD')} ${d}`,
                                                        ) <
                                                            new Date(
                                                                `${moment().format(
                                                                    'YYYY-MM-DD hh:mm A',
                                                                )}`,
                                                            ) &&
                                                            new Date(selectedDate).getDate() ===
                                                                new Date().getDate() &&
                                                            new Date(selectedDate).getMonth() ===
                                                                new Date().getMonth()) ||
                                                        checkTimeValidity(d)
                                                    }
                                                />
                                            }
                                            label={d}
                                        />
                                    ))}
                                </RadioGroup>
                            </FormControl>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}
